/* =============================================================================
DB:       Realtime DB
PATH:     user.{userId}.goal.{goalId}
PURPOSE:  User settings for a goal
============================================================================= */

export default {

  create({ cachedName, sortidx }, data) {
    return {
      cachedName: cachedName,
      // commitmentTime: -1,
      // commitmentWeekdays: "xx-xx--",
      // userPictureOverride: "#ffee00",
      // showFinished: true,
      // size: 100,
      // sortby: "",
      categoryId: data.categoryId || null,
      // isFavorite: data.isFavorite === true,
      isFavorite: data.isFavorite !== undefined ? data.isFavorite : true,
      sortidx: sortidx || 1,
      userLeftGroup: false,
      graphicalRepresentation: {
        x: 200,
        y: 100,
        // width: 300,
        // height: 166,
        scaleX: 1.0,
        scaleY: 1.0,
        rotation: 0,
        shadowColor: 'black',
        shadowBlur: 25,
        shadowOffset: { x : 0, y : 5 },
        shadowOpacity: 0.5,
        zIndex: 2, // Important to put images above each other
        headline: {
          // text: "Have a nice physique", => name
          fontFamily: "Arial",
          fontSize: 24,
          // x: 200,
          // y: 70,
          // draggable: true,
          // fill: '#ffffff',
          // scaleX: 1,
          // scaleY: 1
        },
        showHeadline: true,
        showImage: true,
        showCommitments: true,
        // NEU 26.3.2019
        showTiles: true,
        groupTiles: true,
        showOverallProgress: true,
        tileColor: 'white',
      },
      kanbanSettings: {
        showSidebar:        true,
        showFinishedTasks:  true,
        showArchivedTasks:  false,
        showPropTaskHeight: false,
        compactStyle:       false,
        columnLayout:       false,
      }
    };
  },

  fields: {
    cachedName: { validate_bolt_type: 'String' },
    // userPictureOverride: { validate_bolt_type: 'String' },
    // sortby: {},
    sortidx: { validate_bolt_type: 'Number' },
    userLeftGroup: { validate_bolt_type: 'Boolean' },
    categoryId: { validate_bolt_type: 'AnyID' },
    isFavorite: { validate_bolt_type: 'Boolean' },
    graphicalRepresentation: { validate_bolt_type: 'GoalGraphicalRepresentation' },
    'graphicalRepresentation/x': { /* See schema.bolt */ },
    'graphicalRepresentation/y': { /* See schema.bolt */ },
    'graphicalRepresentation/scaleX': { /* See schema.bolt */ },
    'graphicalRepresentation/scaleY': { /* See schema.bolt */ },
    'graphicalRepresentation/rotation': { /* See schema.bolt */ },
    'graphicalRepresentation/shadowColor': { /* See schema.bolt */ },
    'graphicalRepresentation/shadowBlur': { /* See schema.bolt */ },
    'graphicalRepresentation/shadowOffset/x': { /* See schema.bolt */ },
    'graphicalRepresentation/shadowOffset/y': { /* See schema.bolt */ },
    'graphicalRepresentation/shadowOpacity': { /* See schema.bolt */ },
    'graphicalRepresentation/zIndex': { /* See schema.bolt */ },
    'graphicalRepresentation/headline/fontFamily': { /* See schema.bolt */ },
    'graphicalRepresentation/headline/fontSize': { /* See schema.bolt */ },
    'graphicalRepresentation/showHeadline': { /* See schema.bolt */ },
    'graphicalRepresentation/showImage': { /* See schema.bolt */ },
    'graphicalRepresentation/showCommitments': { /* See schema.bolt */ },
    'graphicalRepresentation/showTiles': { /* See schema.bolt */ },
    'graphicalRepresentation/groupTiles': { /* See schema.bolt */ },
    'graphicalRepresentation/showOverallProgress': { /* See schema.bolt */ },
    'graphicalRepresentation/tileColor': { /* See schema.bolt */ },
    kanbanSettings: { validate_bolt_type: 'GoalKanbanSettings' },
    'kanbanSettings/showSidebar': { /* See schema.bolt */ },
    'kanbanSettings/showFinishedTasks': { /* See schema.bolt */ },
    'kanbanSettings/showArchivedTasks': { /* See schema.bolt */ },
    'kanbanSettings/showPropTaskHeight': { /* See schema.bolt */ },
    'kanbanSettings/compactStyle': { /* See schema.bolt */ },
    'kanbanSettings/columnLayout': { /* See schema.bolt */ },
    /*
    {
      model: 'cachedName',
      validate: () => true,
      validate_bolt_type: "String"
    },
    {
      model: 'graphicalRepresentation',
      validate_bolt_type: "Object" // TODO
    },
    */
  }
};
